import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollLogicComponentListSearchSchema } from '../-shared/payroll-logic-component-list-search-schema';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/logic-components/')({
  validateSearch: zodValidator(PayrollLogicComponentListSearchSchema)
});